// extracted by mini-css-extract-plugin
export default {"container":"PlaceHolder_container__hc+-k","option":"PlaceHolder_option__uBZzE"};